export default __webpack_public_path__ + "static/media/westfield-suite.inline.50e49033.svg";